import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Header from '../../../components/ui/Header';

const CentriMedici = () => {
  const navigate = useNavigate();

  return (
    <>
      {/* Shared Header Component */}
      <Header onFilterClick={() => {}} />
      
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="max-w-2xl mx-auto px-6 text-center">
          <div className="bg-card border border-border rounded-xl shadow-lg p-12">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <Icon name="Stethoscope" size={40} className="text-green-600" />
            </div>
            <h1 className="text-3xl font-bold text-foreground mb-4">
              Centri Medici Privati
            </h1>
            <p className="text-muted-foreground mb-8">
              Questa funzionalità sarà disponibile a breve.
            </p>
            <button
              onClick={() => navigate('/farma-service-city')}
              className="bg-green-600 hover:bg-green-700 text-white font-semibold px-6 py-3 rounded-lg shadow-md transition-all duration-200"
            >
              Torna ai Servizi
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CentriMedici;